export default __webpack_public_path__ + "static/media/Randy Fine.ef79e645.jpg";